module.exports = __webpack_public_path__ + "frame-59ed99bf/anschreiben-logo-dark-a8c9b78fd05c8f1db9201aceebad6a0e.svg";